import * as React from 'react';
import height from "../../assets/icon/height.gif";
import weight from "../../assets/icon/weight.gif";
import careStore from "../../store/careStore";
import api from "../../utils/api";
import { useEffect } from "react";

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import InputAdornment from '@mui/material/InputAdornment';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
// @ts-ignore
import GaugeChart from 'react-gauge-chart';
import GaugeComponent from 'react-gauge-component'


const CareInfo = (props: any) => {
  const divArea = 16.6;
  const storeData: any = careStore();
  const [heightError, setHeightError] = React.useState(false);
  const [weightError, setWeightError] = React.useState(false);
  const [bmiPersent, setBmiPersent] = React.useState(0);

  useEffect(() => {
    setBmiPersent(calculateBMI(true));

    return () => {
      storeData.setCareInfo('interest_disease', '');
      storeData.setCareInfo('work_strength', '');
      storeData.setCareInfo('goal', '');
      storeData.setCareInfo('food', '');
    }
  }, []);

  // 신장 입력 핸들러
  function handleChangeHeight(val: any) {
    storeData.setCareInfo('height', val);
    if (val >= 50 && val <= 250) {
      setHeightError(false);
      setBmiPersent(calculateBMI(false));
    } else {
      setHeightError(true);
    }
  }

  // 체중 입력 핸들러
  function handleChangeWeight(val: any) {
    storeData.setCareInfo('weight', val);
    if (val >= 10 && val <= 300) {
      setWeightError(false);
      setBmiPersent(calculateBMI(false));
      console.log(calculateBMI(false))
    } else {
      setWeightError(true);
    }
  }

  // BMI 값 구하기(소수점 한자리 반올림)
  function calculateBMI(init: any) {
    let bmi = 0;
    if (init) {
      bmi = storeData.careInfo.bmi;
    } else {
      bmi = Number((storeData.careInfo.weight / ((storeData.careInfo.height / 100) * (storeData.careInfo.height / 100))).toFixed(1));
    }
    storeData.setCareInfo('bmi', bmi);

    let bmiPersent = 0;
    if (bmi > 0 && bmi <= 18.5) {
      bmiPersent = divArea * (bmi) / (18.5) * 100 / 100;
    } else if (bmi > 18.5 && bmi <= 23) {
      bmiPersent = (divArea) + divArea * (bmi - 18.5) / (23 - 18.5) * 100 / 100;
    } else if (bmi > 23 && bmi <= 25) {
      bmiPersent = (divArea * 2) + divArea * (bmi - 23) / (25 - 23) * 100 / 100;
    } else if (bmi > 25 && bmi <= 30) {
      bmiPersent = (divArea * 3) + divArea * (bmi - 25) / (30 - 25) * 100 / 100;
    } else if (bmi > 30 && bmi <= 35) {
      bmiPersent = (divArea * 4) + divArea * (bmi - 30) / (35 - 30) * 100 / 100;
    } else if (bmi > 35) {
      bmiPersent = (divArea * 5) + divArea * (bmi - 35) / (100 - 35) * 100 / 100;
    }
    return bmiPersent / 100;
  }

  const bmiStep = {
    p: '0 !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center'

  }



  return (
    <Stack sx={{ width: '100%', background: '#fff', minWidth: 320, minHeight: 515 }} spacing={2}>

      <Grid sx={{ bgcolor: '#fff', p: 1, pb: 2, pt: 3, width: '100%', mt: 1, }}>
        <Box sx={{}}>
          <Typography component="div" sx={{ fontSize: 18, color: '#555', m: 1, mb: 1, textAlign: 'center' }}>
            신장을 입력해주세요
          </Typography>
          <Grid container justifyContent="center" direction={'row'}>
            <Avatar alt="" src={height} sx={{ width: 60, height: 54, borderRadius: '5px 0 0 5px', border: '1px solid #c4c4c4', borderRight: 0, }} />
            <TextField
              label="신장"
              id="outlined-start-adornment"
              sx={{
                m: 0, ml: '-1px', width: '70%',
                '& .MuiOutlinedInput-root': { borderRadius: '0 5px 5px 0' }
              }}
              onChange={(e) => { handleChangeHeight(e.target.value) }}
              defaultValue={storeData.careInfo.height}
              InputProps={{
                endAdornment: <InputAdornment position="start" sx={{}}>cm</InputAdornment>,
              }}
              error={heightError}
              helperText={heightError ? "50 ~ 250 사이의 값을 입력해주세요." : ""}
            />
          </Grid>

          <Typography component="div" sx={{ fontSize: 18, color: '#777', m: 2, mb: 1, mt: 3, textAlign: 'center' }}>
            체중을 입력해주세요
          </Typography>
          <Grid container justifyContent="center">
            <Avatar alt="" src={weight} sx={{ width: 60, height: 54, borderRadius: '5px 0 0 5px', border: '1px solid #c4c4c4', borderRight: 0, '& img': { width: '90%', height: '90%' } }} />
            <TextField
              label="체중"
              id="outlined-start-adornment"
              sx={{
                m: 0, ml: '-1px', width: '70%',
                '& .MuiOutlinedInput-root': { borderRadius: '0 5px 5px 0' }
              }}
              onChange={(e) => { handleChangeWeight(e.target.value) }}
              defaultValue={storeData.careInfo.weight}
              InputProps={{
                endAdornment: <InputAdornment position="start">kg</InputAdornment>,
              }}
              error={weightError}
              helperText={weightError ? "10 ~ 300 사이의 값을 입력해주세요." : ""}
            />
          </Grid>
        </Box>
      </Grid>
      <Box sx={{ pt: 2, pb: 1, background: '#fafafa' }}>
        <GaugeComponent
          type="semicircle"
          arc={{
            gradient: true,
            width: 0.1,
            padding: 0,
            subArcs: [
              {
                limit: divArea*1,
                color: '#0099ff',
                showTick: false
              },
              {
                limit: divArea*2,
                color: '#00aa00',
                showTick: false
              },
              {
                limit: divArea*3,
                color: '#bb8800',
                showTick: false
              },
              {
                limit: divArea*4,
                color: '#ff5555',
                showTick: false
              },
              {
                limit: divArea*5,
                color: '#b35fd6',
                showTick: false
              },
              {
                limit: 100,
                color: '#3b44c7',
                showTick: false
              },
            ]
          }}
          value={Math.floor(bmiPersent*100)}
          minValue={0}
          maxValue={100}
          pointer={{ type: "blob", animationDelay: 0 }}
          labels={{
            valueLabel: {
              formatTextValue: value => 'BMI : ' + storeData.careInfo.bmi + '',
              style: { fontSize: "30px", fill: "#000", textShadow: "0" }
            },
            tickLabels: {
              //type: "outer",
              ticks: [
                { value: 0, valueConfig: { formatTextValue: (value: any) => '' } },
                { value: divArea*1, valueConfig: { formatTextValue: (value: any) => '18.5' } },
                { value: divArea*2, valueConfig: { formatTextValue: (value: any) => '23' } },
                { value: divArea*3, valueConfig: { formatTextValue: (value: any) => '25' } },
                { value: divArea*4, valueConfig: { formatTextValue: (value: any) => '30' } },
                { value: divArea*5, valueConfig: { formatTextValue: (value: any) => '35' } },
                { value: 100, valueConfig: { formatTextValue: (value: any) => '' } }
              ]
            }

          }}
        />


      {/*  gauge chart 사용 라이브러리 :  https://github.com/Martin36/react-gauge-chart?tab=readme-ov-file   */}
      {/* <Box sx={{ pt: 2, pb: 1, background: '#fafafa' }}>
        <GaugeChart id="gauge-chart5"
          nrOfLevels={6}
          arcsLength={[divArea / 100, divArea / 100, divArea / 100, divArea / 100, divArea / 100, divArea / 100]}
          colors={['#0099ff', '#00aa00', '#bb8800', '#ff5555', '#b35fd6', '#3b44c7']}
          percent={bmiPersent}
          arcPadding={0.01}
          needleScale={0.7}
          textColor="black"
          needleColor="red"
          fontSize="24"
          formatTextValue={(value: any) => 'BMI : ' + storeData.careInfo.bmi + ''}
          style={{}}
          animDelay="200"
          animateDuration="1200"
        /> */}
        {/*   참고한 사이트 : https://www.hanam.go.kr/health/contents.do?key=8926  */}

        <Grid container spacing={0} padding={'0 20px'} height={30} sx={{mt:1}}>
          <Grid item xs={2} bgcolor={'rgb(0, 153, 255)'} fontSize={12} color={'#fff'} sx={bmiStep}>
            저체충
          </Grid>
          <Grid item xs={2} bgcolor={'rgb(0, 170, 0)'} fontSize={12} color={'#fff'} sx={bmiStep}>
            정상
          </Grid>
          <Grid item xs={2} bgcolor={'rgb(187, 136, 0)'} fontSize={12} color={'#fff'} sx={bmiStep}>
            비만전 <br />단계
          </Grid>
          <Grid item xs={2} bgcolor={'rgb(255, 85, 85)'} fontSize={12} color={'#fff'} sx={bmiStep}>
            1단계 <br /> 비만
          </Grid>
          <Grid item xs={2} bgcolor={'rgb(179, 95, 214)'} fontSize={12} color={'#fff'} sx={bmiStep}>
            2단계 <br /> 비만
          </Grid>
          <Grid item xs={2} bgcolor={'rgb(59, 68, 199)'} fontSize={12} color={'#fff'} sx={bmiStep}>
            3단계 <br />비만
          </Grid>
        </Grid>
        <Grid container spacing={0} padding={'0 20px'} margin={'2px 0 0 -4px'}>
          <Grid item xs={2} fontSize={12} color={'#555'}>
            0
          </Grid>
          <Grid item xs={2} fontSize={12} color={'#555'}>
            18.5
          </Grid>
          <Grid item xs={2} fontSize={12} color={'#555'}>
            23
          </Grid>
          <Grid item xs={2} fontSize={12} color={'#555'}>
            25
          </Grid>
          <Grid item xs={2} fontSize={12} color={'#555'}>
            30
          </Grid>
          <Grid item xs={2} fontSize={12} color={'#555'}>
            35
          </Grid>
        </Grid>


        
        <Box sx={{ textAlign: 'right', pr: 3 }}>
          <Typography sx={{ mt: 2, fontSize: 11, fontWeight: 700, color: '#aaa' }}></Typography>
          <Typography sx={{ fontSize: 11, overflowWrap: 'break-word', ml: 1, color: '#aaa' }}>출처 : 질병관리청(국가건강정보포털), <a href="https://health.kdca.go.kr/healthinfo/biz/health/main/mainPage/main.do" title="질병관리청" target='_blank' style={{ textDecoration: 'none', color: '#aaa', fontSize: 11 }}>https://health.kdca.go.kr</a></Typography>
        </Box>
      </Box>



    </Stack >

  );
}

export default CareInfo;